<template>
  <component
    :is="available && route ? 'a' : 'div'"
    class="w-tile atlas-country-tile"
    :class="{
      'w-cursor-click': available && route,
      'atlas-country-unavailable': !available || !route
    }"
    :href="available && route ? route : undefined"
    :aria-label="available && route ? name : undefined"
  >

    <!-- Country photograph -->
    <div
      class="c-image-part"
      :style="{
        backgroundImage: image ? 'url(' + image + ')' : 'none'
      }"
    >
    </div>

    <!-- Country flag -->
    <img
      v-if="flag"
      class="atlas-country-flag"
      :src="flag"
      :alt="name"
    >

    <!-- Country information -->
    <div class="c-text-part">

      <p class="c-title">
        {{ name }}
      </p>

      <p class="c-subtitle">
        {{ available ? subtitle : translate("available soon") }}
      </p>

    </div>

  </component>
</template>

<script>
import { translate_word } from '../assets/js/translate.js';

export default {
  name: 'AtlasCountryTile',

  props: {
    name: {
      type: String,
      required: true
    },

    subtitle: {
      type: String,
      default: ''
    },

    image: {
      type: String,
      default: ''
    },

    flag: {
      type: String,
      default: ''
    },

    available: {
      type: Boolean,
      default: false
    },

    route: {
      type: String,
      default: ''
    }
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language;
    }
  },

  methods: {
    translate(string) {
      return translate_word(string, this.currentLanguage);
    }
  }
};
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
/* =========================================
   COUNTRY TILE
   ========================================= */

.atlas-country-tile {
  position: relative;
  display: block;
  overflow: hidden;
  flex: 0 0 300px;

  /* Works for both <a> and <div> */
  color: inherit;
  text-decoration: none;
}

/* =========================================
   LINK BEHAVIOUR
   ========================================= */

.atlas-country-tile:hover {
  color: inherit;
  text-decoration: none;
}

.atlas-country-tile:focus-visible {
  outline: 3px solid rgb(109,122,82);
  outline-offset: 3px;
}

/* =========================================
   COUNTRY FLAG
   ========================================= */

.atlas-country-flag {
  position: absolute;
  top: 10px;
  right: 10px;

  width: 32px;
  height: 22px;

  object-fit: cover;

  border: none;
  border-radius: 2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.20);

  z-index: 2;
}

/* =========================================
   UNAVAILABLE COUNTRIES
   ========================================= */

.atlas-country-unavailable {
  cursor: default;
}

.atlas-country-unavailable .c-image-part {
  filter: grayscale(40%);
}

/* =========================================
   HOVER EFFECT
   ========================================= */

.atlas-country-tile.w-cursor-click:hover {
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.45);
}

/* =========================================
   COUNTRY PHOTOGRAPH
   ========================================= */

.atlas-country-tile .c-image-part {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 75%;

  background-size: cover;
  background-position: center;

  border-radius: 15px 15px 0 0;
}

/* =========================================
   COUNTRY INFORMATION
   ========================================= */

.atlas-country-tile .c-text-part {
  position: absolute;
  top: 75%;
  left: 0;

  width: 100%;
  height: 25%;

  background-color: #FFFCF5;
  border-radius: 0 0 15px 15px;
}

/* =========================================
   COUNTRY NAME
   ========================================= */

.atlas-country-tile .c-title {
  position: absolute;
  top: 5px;
  left: 10px;

  margin: 0;

  font-size: 16px;
  font-weight: bold;
}

/* =========================================
   COUNTRY SUBTITLE
   ========================================= */

.atlas-country-tile .c-subtitle {
  position: absolute;
  bottom: 5px;
  left: 10px;

  margin: 0;

  font-size: 12px;
}
</style>